import { render } from "./FilterATSalesmanDistributorSalesman.vue?vue&type=template&id=c2e023e2"
import script from "./FilterATSalesmanDistributorSalesman.vue?vue&type=script&lang=js"
export * from "./FilterATSalesmanDistributorSalesman.vue?vue&type=script&lang=js"
script.render = render

export default script